import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component
export default class BalaWritingIntro extends Vue {
  submit() {
    this.$store.dispatch("updateBalaProgress", {
      section: "Writing Task",
      subsection: "Intro"
    });
    this.$router.push({ name: "balaWT1Intro" });
  }

  render(h: CreateElement) {
    return (
      <Card>
        <div slot="mainContent" style={{ textAlign: "center" }}>
          <span class="subtitle-1">
            Let’s focus on writing now! Writing is an important skill for
            learning and sharing ideas. You are going to see a short video based
            on children’s use of social media, then you will be asked to write
            about that topic. As you write, pay attention to the five key
            writing skills.
          </span>
          <br />
          <br />
          <v-img
            src={require("@/assets/bala_writing_explanation.png")}
            max-width="450px"
            style={{ margin: "0 auto" }}
          ></v-img>
        </div>
        <div slot="actions">
          <v-btn color="secondary" onClick={this.submit}>
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(this.$store.getters.progressBala)}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = BalaWritingIntro;
